import React, { ChangeEvent, InputHTMLAttributes } from 'react';

import styles from './styles.module.css';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  setChecked: (checked: boolean) => void;
  variant: 'primary' | 'secondary';
}

export const Checkbox: React.FC<CheckboxProps> = ({
  id,
  checked = false,
  setChecked,
  variant = 'primary',
  onChange,
  ...props
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
    onChange?.(e);
  };

  return (
    <label htmlFor={id} className={`${styles.checkbox} ${styles[variant]}`}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        {...props}
      />
    </label>
  );
};
